import React from 'react';

export const LazyProfile = React.lazy<typeof import('../Profile').Profile>(() =>
  import('../Profile').then((module) => ({ default: module.Profile })),
);
